import { api } from "@/services/api"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import useEvents from "@/modules/calendar/stores/use-events"

export default function useCreateEvent() {
  const queryClient = useQueryClient()
  const { addEvents } = useEvents()

  const mutation = useMutation({
    mutationFn: api.cronos.user.events.create,
    onSuccess(data) {
      const newEvents = data.data.description
      addEvents(newEvents)
    },
    onSettled() {
      queryClient.invalidateQueries({ queryKey: ["get-daily-calendar"] })
    },
  })

  return mutation
}
